<template>
    <WidgetList state="add" />
</template>

<script>
import WidgetList from '@/components/Settings/Widgets/WidgetList'
export default {
    name: 'NewWidget',
    components:{
        WidgetList
    }
}
</script>